import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL_DEFAULT = 'https://your-project.supabase.co'
const SUPABASE_ANON_KEY_DEFAULT = 'your-anon-key'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

const isMissingUrl = !supabaseUrl || supabaseUrl === SUPABASE_URL_DEFAULT
const isMissingAnonKey = !supabaseAnonKey || supabaseAnonKey === SUPABASE_ANON_KEY_DEFAULT

let supabaseConfigError = null
let supabase = null

if (isMissingUrl || isMissingAnonKey) {
  supabaseConfigError = new Error(
    'Supabase is not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in your environment.'
  )
  console.error(
    '[Auth] Supabase configuration error:',
    {
      message: supabaseConfigError.message,
      supabaseUrl: supabaseUrl || 'not set',
      supabaseAnonKey: supabaseAnonKey ? 'set' : 'not set'
    }
  )
} else {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
}

export { supabase, supabaseConfigError }
